var map = {
	"./accordeon-minus.svg": 4,
	"./accordeon-plus.svg": 5,
	"./arrow.svg": 6,
	"./badge.svg": 7,
	"./book.svg": 8,
	"./bullet-1.svg": 9,
	"./bullet-2.svg": 10,
	"./bullet.svg": 11,
	"./calendar-heart.svg": 12,
	"./calendar.svg": 13,
	"./check.svg": 14,
	"./circles-pattern.svg": 15,
	"./circles-white.svg": 16,
	"./circles.svg": 17,
	"./clock.svg": 18,
	"./close.svg": 19,
	"./download-button.svg": 20,
	"./download-mobile.svg": 21,
	"./download.svg": 22,
	"./email.svg": 23,
	"./event-check.svg": 24,
	"./event-type.svg": 25,
	"./external-link.svg": 26,
	"./facebook.svg": 27,
	"./filter.svg": 28,
	"./footer.svg": 29,
	"./format.svg": 30,
	"./heart-filled.svg": 31,
	"./heart-hand.svg": 32,
	"./heart-line.svg": 33,
	"./hint.svg": 34,
	"./house-heart-thin.svg": 35,
	"./house-heart.svg": 36,
	"./info-circle.svg": 37,
	"./info.svg": 38,
	"./instagram.svg": 39,
	"./lecturer.svg": 40,
	"./live-presence.svg": 41,
	"./logo-akademie-small.svg": 42,
	"./logo-akademie.svg": 43,
	"./maps-pin.svg": 44,
	"./mobile-phone.svg": 45,
	"./online-talk.svg": 46,
	"./pdf.svg": 47,
	"./phone.svg": 48,
	"./plus.svg": 49,
	"./pointer.svg": 50,
	"./question-circle.svg": 51,
	"./quote.svg": 52,
	"./search.svg": 53,
	"./select-box-arrow.svg": 54,
	"./services.svg": 55,
	"./slide-arrow-left.svg": 56,
	"./slide-arrow-right.svg": 57,
	"./submenu-arrow.svg": 58,
	"./target.svg": 59,
	"./team.svg": 60,
	"./topic.svg": 61,
	"./video.svg": 62,
	"./youtube.svg": 63,
	"./zip.svg": 64,
	"./zoom.svg": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;